/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'slices'
import handleAxiosError from 'utils/handleAxiosError'
import { BroadcastContact } from 'types'
import getBroadcastContacts, {
	GetBroadcastContactsResponse,
} from 'api/broadcast/getBroadcastContacts'

interface BroadcastContactsState {
	loading: boolean
	totalCount: number
	records: BroadcastContact[]
	totalPages: number
	currentPage: number
	page: number
	size: number
	query: string
	process: boolean
}

const initialState: BroadcastContactsState = {
	loading: false,
	totalCount: 0,
	records: [],
	totalPages: 1,
	currentPage: 1,
	page: 1,
	size: 10,
	query: '',
	process: true,
}

interface argumentType {
	id: string
	process?: boolean
}

export const getBroadcastContactsAction = createAsyncThunk<
	GetBroadcastContactsResponse,
	argumentType,
	{ state: RootState }
>(
	'broadcastContact/getBroadcastContactsAction',
	async ({ id, process }, { rejectWithValue, getState }) => {
		try {
			const { page, size, query } = getState().broadcastContact
			const options = { page, size, query, id, process }
			return await getBroadcastContacts(options)
		} catch (error: any) {
			handleAxiosError(error)
			return rejectWithValue(error.message)
		}
	}
)

const broadcastContactSlice = createSlice({
	name: 'broadcastContact',
	initialState,
	reducers: {
		updateBroadcastContactPageAction: (state, action: PayloadAction<number>) => {
			state.page = action.payload
		},
		updateBroadcastContactQueryAction: (state, action: PayloadAction<string>) => {
			state.query = action.payload
		},
		updateBroadcastContactProcessAction: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.process = action.payload
			state.page = 1
		},
		clearBroadcastContactAction: () => initialState,
	},
	extraReducers: builder => {
		builder.addCase(getBroadcastContactsAction.pending, state => {
			state.loading = true
		})
		builder.addCase(getBroadcastContactsAction.fulfilled, (state, action) => {
			state.loading = false
			state.totalCount = action.payload.totalCount
			state.records = action.payload.records
			state.totalPages = action.payload.totalPages
			state.currentPage = action.payload.currentPage
		})
		builder.addCase(getBroadcastContactsAction.rejected, state => {
			state.loading = false
			state.page = state.currentPage
		})
	},
})

export const {
	updateBroadcastContactPageAction,
	updateBroadcastContactProcessAction,
	updateBroadcastContactQueryAction,
	clearBroadcastContactAction,
} = broadcastContactSlice.actions

export default broadcastContactSlice.reducer
